import React from 'react';

const Logout = () => {
    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.reload(); // Atualiza a página
    };

    return (
        <button className='logout-button' onClick={handleLogout}>
            <i className="bi bi-person-fill-dash">
                <span className="description">
                Sair
                </span>
            </i>
        </button>
    );
};

export default Logout;
